// extracted by mini-css-extract-plugin
module.exports = {"atlas":"atlas-QXVWybV_","pic":"pic-1i5FaHA_","txt":"txt-3iFdbqEc","pagenum":"pagenum-2198kAaF","num":"num-3HKHxGTU","title":"title-2sF8swxQ"};